import { Api } from "./api"

const PATH = 'mecanicien' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    Enable:'enable',
    Disable:'disable',
    Banish:'banish',
    CanManageAnnonce:'manage-annonce'
}

const getProviders = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getProvider = (id,signal) => {
    return Api.get(`${PATH}/${id}/${ENDPOINTS.Show}`, signal)
}

const storeProvider = (payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`,payload, signal)
}

const updateProvider = (id,payload,signal) => {
    return Api.update(`${PATH}/${ENDPOINTS.Update}/${id}`,payload, signal)
}

const deleteProvider = (id,signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

const enable = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Enable}/${id}`, signal)
}

const disable = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Disable}/${id}`, signal)
}

const banish = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Banish}/${id}`, signal)
}

const canManageAnnonce = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.CanManageAnnonce}/${id}`, signal)
}

export const providerApi={
    getProviders,
    getProvider,
    storeProvider,
    updateProvider,
    deleteProvider,
    enable,
    disable,
    banish,
    canManageAnnonce    
}